import { Component } from "@angular/core"
import { ViewController } from "ionic-angular"

@Component({
  selector: "help-page",
  templateUrl: "index.html",
})
export class HelpPage {

  constructor(
    private viewCtrl: ViewController
  ) {}

  ionViewWillEnter() {

    this.viewCtrl.setBackButtonText("Voltar")
  }
}



// WEBPACK FOOTER //
// ./src/pages/help/index.ts